<template>
  <div>
    <Edit
      :editDialog="editDialog"
      @updated="updated"
      :editOrg="organization"
      @close="editDialog = false"
    >
    </Edit>
    <v-layout
      class="mt-5"
      v-if="isLoading"
      align-center="align-center"
      justify-center="justify-center"
      column="column"
      fill-height="fill-height"
    >
      <v-progress-circular size="70" width="7" color="purple" indeterminate="indeterminate">
      </v-progress-circular>
      <div>Loading...</div>
    </v-layout>
    <div v-if="!isLoading">
      <v-alert
        class="ma-0"
        transition="slide-y-reverse-transition"
        :value="organization.alertOn"
        type="warning"
      >
        <v-layout column="column">
          <h2 class="headline font-weight-medium">Organization Note</h2>
          <p>{{ organization.notes }}</p>
        </v-layout>
      </v-alert>
      <v-toolbar class="elevation-0" color="info" dark="dark">
        <v-toolbar-title>
          <v-icon class="mr-1" medium="medium">business</v-icon>
          <span>{{ organization.organizationName }}</span>
        </v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-menu bottom="bottom" left="left">
          <v-btn slot="activator" icon="icon">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="editDialog = true" v-if="checkRightStatus(52)">
              <v-list-tile-content>
                <v-list-tile-title>{{ $t("buttons.edit") }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="bringStore" v-if="checkRightStatus(54)">
              <v-list-tile-content>
                <v-list-tile-title>{{ $t("buttons.bringStore") }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="softwareUpdate" v-if="checkRightStatus(49)">
              <v-list-tile-content>
                <v-list-tile-title>{{ $t("buttons.giveUpdate") }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider> </v-divider>
            <v-list-tile @click="openActivity">
              <v-list-tile-content>
                <v-list-tile-title>{{ $t("buttons.activity") }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <Activity
        :activityDialog="activityDialog"
        @close="closeActivity"
        :refID="organization.organizationID"
        typeId="2"
      >
      </Activity>
      <v-container fluid="fluid" grid-list-lg="grid-list-lg">
        <v-layout row="row" wrap="wrap">
          <v-flex xs12="xs12" sm4="sm4">
            <v-layout column="column">
              <v-flex>
                <v-card>
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title>
                      <h1 class="subheading">{{ $t("labels.contactInformation") }}</h1>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout column="column">
                      <v-layout row="row" wrap="wrap">
                        <v-flex>{{ $t("labels.primary") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          organization.primaryPhone
                        }}</v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row="row" wrap="wrap">
                        <v-flex>{{ $t("labels.secondary") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          organization.secondaryPhone
                        }}</v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row="row" wrap="wrap">
                        <v-flex>{{ $t("labels.primaryEmail") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">
                          <a @click="sendEmail(organization.primaryEmail)">{{
                            organization.primaryEmail
                          }}</a>
                        </v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row="row" wrap="wrap">
                        <v-flex>{{ $t("labels.secondaryEmail") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">
                          <a @click="sendEmail(organization.secondaryEmail)">{{
                            organization.secondaryEmail
                          }}</a>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex>
                <v-card>
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title>
                      <h1 class="subheading">{{ $t("labels.loginInformation") }}</h1>
                    </v-toolbar-title>
                    <v-spacer> </v-spacer>
                    <v-btn small="small" color="pink" dark="dark" icon="icon" @click="editLogin">
                      <v-icon small="small">edit</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout column="column">
                      <v-layout row="row" wrap="wrap">
                        <v-flex>{{ $t("labels.login") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">
                          <a @click="sendEmail(organization.loginEmail)">{{
                            organization.loginEmail
                          }}</a>
                        </v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row="row" wrap="wrap">
                        <v-flex>{{ $t("labels.password") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">
                          <a @click="sendPassword">{{ $t("labels.sendPassword") }}</a>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex v-if="checkRightStatus(59)">
                <v-card>
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title>
                      <h1 class="subheading">{{ $t("labels.whiteLabel") }}</h1>
                    </v-toolbar-title>
                    <v-spacer> </v-spacer>
                    <v-btn
                      small="small"
                      color="pink"
                      dark="dark"
                      icon="icon"
                      @click="editWhiteLabel"
                    >
                      <v-icon small="small">edit</v-icon>
                    </v-btn>
                  </v-toolbar>
                </v-card>
                <WhiteLabel
                  :whiteLabel="organization.whiteLabel"
                  :createDialog="whiteLabelDialog"
                  @close="closeWhiteLabelDialog"
                  @update="updateWhiteLabel"
                >
                </WhiteLabel>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12="xs12" sm8="sm8">
            <v-layout column="column">
              <v-flex>
                <v-card>
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title>
                      <h1 class="subheading">{{ $t("labels.note") }}</h1>
                    </v-toolbar-title>
                    <v-spacer> </v-spacer>
                    <toggle-button
                      @change="updateAlert"
                      :labels="true"
                      color="red"
                      v-model="organization.alertOn"
                      :value="organization.alertOn"
                      :sync="true"
                    >
                    </toggle-button>
                    <v-btn small="small" color="info" dark="dark" icon="icon" @click="updateNote()">
                      <v-icon small="small">save</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-textarea rows="12" v-model="organization.notes"> </v-textarea>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <OtherStoreList :location="organization.Stores"> </OtherStoreList>
      </v-container>
    </div>
  </div>
</template>

<script>
import organizationService from "../service.js";
import locationService from "../../Location/service.js";
import Activity from "../../Comment/components/ActivityDialog";
import OtherStoreList from "../../Location/components/OtherStoreList";
import WhiteLabel from "../views/WhiteLabel";
import { mapGetters, mapActions } from "vuex";
const Edit = () => import("../components/Edit");

export default {
  data() {
    return {
      editDialog: false,
      organization: null,
      isLoading: true,
      activityDialog: false,
      whiteLabelDialog: false
    };
  },
  computed: {
    ...mapGetters("global", ["checkRightStatus"])
  },
  async created() {
    await this.loadOrganization();
    this.setPageTitle(this.organization.organizationName + " - Organization");
  },
  components: {
    Activity,
    Edit,
    OtherStoreList,
    WhiteLabel
  },
  methods: {
    ...mapActions("global", ["setPageTitle", "sendEmail"]),
    ...mapActions("location", ["setOrganization"]),
    editWhiteLabel() {
      this.whiteLabelDialog = true;
    },
    closeWhiteLabelDialog() {
      this.whiteLabelDialog = false;
    },
    whiteLabelUpdated() {
      this.closeWhiteLabelDialog();
      this.loadOrganization();
    },
    updated() {
      this.editDialog = false;
      this.loadOrganization();
    },
    async bringStore() {
      const { value: text } = await this.$swal.fire({
        title: "Enter CSPID",
        input: "text",
        confirmButtonText: "Move",
        showCancelButton: true
      });
      if (text) {
        let data = {
          CSPID: text,
          organizationID: this.organization.organizationID,
          organizationName: this.organization.organizationName
        };
        return organizationService.bringStore(data).then(result => {
          console.log("org result", result);
          this.$swal({
            title: "Successfully moved!",
            text: `${text} was moved to ${this.organization.organizationName}`,
            type: "success"
          });
          this.loadOrganization();
        });
      }
    },
    softwareUpdate() {
      this.$swal({
        title: this.$t("messages.title.areYouSure"),
        html: `you want give update to <b>${
          this.organization.organizationName
        }</b> and all other locations.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("buttons.no"),
        confirmButtonText: this.$t("buttons.yes")
      })
        .then(result => {
          if (result.value) {
            locationService.giveSoftwareUpdate(this.organization.organizationID).then(response => {
              this.$swal("Update", response, "success");
            });
          }
        })
        .catch(error => {
          // todo present this to the user
          console.log(error);
        });
    },
    async editLogin() {
      const { value: text } = await this.$swal.fire({
        title: "New Login Email",
        input: "email",
        showCancelButton: true
      });
      if (text) {
        let data = {
          loginEmail: text
        };
        return organizationService
          .update(this.organization.organizationID, data)
          .then(result => {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "success",
                title: "Email address was change successfully."
              });
            this.loadOrganization();
          })
          .catch(err => {
            this.$swal({
              title: `Change Login Email`,
              text: `${err.data.data.loginEmail} is already been used in ${
                err.data.data.organizationName
              }`,
              type: "error"
            });
          });
      }
    },
    updateAlert(val) {
      let data = {
        alertOn: val.value
      };
      this.updateOrganization(data);
    },
    updateNote() {
      this.updateOrganization({ notes: this.organization.notes });
    },
    updateWhiteLabel(whiteLabel) {
      this.updateOrganization({ whiteLabel: whiteLabel });
    },
    sendPassword() {
      let data = {
        emailAddress: this.organization.loginEmail,
        subject: "Password for test email",
        password: this.organization.loginPassword,
        ownerName: this.organization.ownerName,
        loginEmail: this.organization.loginEmail,
        organizationID: this.organization.organizationID
      };
      locationService.sendPassword(data).then(result => {
        if (result.status) {
          this.$swal(
            "Password!",
            `Password was send to ${this.organization.loginEmail}.`,
            "success"
          );
        }
      });
    },
    updateOrganization(data) {
      return organizationService.update(this.organization.organizationID, data).then(result => {
        if (result.status) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            })
            .fire({
              type: "success",
              title: result.data
            });
        }
        console.log("result", result);
        // this.setLocation(this.location.storeID)
      });
    },
    openActivity() {
      this.activityDialog = true;
    },
    closeActivity() {
      this.activityDialog = false;
    },
    loadOrganization() {
      if (!this.$route.params || !this.$route.params.id) return this.$router.push("/organization");
      const id = this.$route.params.id;
      this.$Progress.start();
      return organizationService.getById(id).then(result => {
        this.organization = result.data;
        this.setOrganization(result.data);
        this.isLoading = false;
        this.$Progress.finish();
      });
      this.$Progress.finish();
    }
  }
};
</script>
